export default "__VITE_ASSET__Cpb_vKJi__"